import { BoundingBox } from '@moleculeone/types';

import { styled } from '../../../../stitches.config';
import { Button as CoreButton } from '../../../controls/Button/Button';

const MOL_CONTAINER_PADDING = 90;

const Container = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  height: '100%',
});

const Button = styled(CoreButton, {
  'height': '100%',
  'padding': '$2 !important',
  '& > span': {
    fontSize: '$3 !important',
  },
});

export interface MoleculeContextProps {
  bbox: BoundingBox;
  scale: number;
  moleculeId: string;
}

interface ExpandButtonProps extends MoleculeContextProps {
  onClick: () => void;
}

export function ExpandButton(props: ExpandButtonProps) {
  const { bbox, scale, onClick } = props;

  if (!bbox.size) {
    return null;
  }

  return (
    <foreignObject
      x={bbox.min[0] - MOL_CONTAINER_PADDING / scale}
      y={bbox.min[1] - MOL_CONTAINER_PADDING / scale}
      width={(bbox.size[0] + MOL_CONTAINER_PADDING * 2) / scale + 20}
      height={(bbox.size[1] + MOL_CONTAINER_PADDING * 2) / scale}
      style={{
        transform: `scale(${scale}, ${scale})`,
        transformOrigin: `${bbox.min[0]}px ${bbox.min[1]}px`,
        overflow: 'visible',
      }}
    >
      <Container>
        <Button size="small" theme="purple" icon="start" onClick={onClick} />
      </Container>
    </foreignObject>
  );
}
